import React from 'react';

import { isMobileOnly } from 'react-device-detect';
import { Divider } from 'antd';

import GlobalIcon from 'components/atoms/GlobalIcon';
import MobileIcon from 'components/atoms/MobileIcon';
import ShareIcon from 'components/atoms/ShareIcon';
import LinkIcon from 'components/atoms/LinkIcon';
import { CreativeType } from 'types/creative';
import { useAppState } from 'context';
import { PLAYBACK_TYPE } from 'services/constants';

import './HeaderIcons.scss';

type HeaderIconsProps = {
  vertical?: boolean
}

const HeaderIcons = (props: HeaderIconsProps) => {
  const { vertical = false } = props;
  // Grabbing category to conditionally render some vs. all icons later dep on creative type
  const { creative: { playback_id: playbackId } = {} as CreativeType } = useAppState();
  const partialView = playbackId === PLAYBACK_TYPE.ctv ||  playbackId === PLAYBACK_TYPE.tiktok;
  return (
    <div className={`option-bar ${vertical ? 'vertical' : 'horizontal'}`}>
      {!vertical && !partialView && 'ALTERNATE VIEWS'}
      {!vertical && !partialView && <Divider type='vertical' className='verDiv' />}
      {/* {!partialView &&  <GlobalIcon />} */}
      {!isMobileOnly && !partialView && <MobileIcon />}
      {!vertical && !partialView && <Divider type='vertical' className='verDiv'/> }
      <ShareIcon/>
      {/*<LinkIcon /> */}
      {/* {partialView && !partialView && <Divider type='vertical' className='verDiv'/> } */}
    </div>
  );
}

export default HeaderIcons;
